"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("rxjs/add/observable/never");
const Observable_1 = require("rxjs/Observable");
const idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
const settings_message_1 = require("./settings-message");
const idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
/**
 * Incorporates fundamental functionality of "settings" components. Namely, should provide inter-component communication
 * facilities and similar basic infrastructure.
 */
class SettingsBase {
    /**
     * Initializes the state and organizes communication with other related settings components.
     * If the service is not provided for communication then no actions are performed at all.
     * @param {T} self the identifier of the component
     * @param {CommunicationService} communicationService the optional service for inter-component communication
     */
    constructor(self, communicationService = null) {
        this.self = self;
        this.communicationService = communicationService;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(self);
        idm_common_util_frontend_1.PreconditionCheck.notUndefined(communicationService);
        this.peers = new Set();
    }
    /**
     * Initiate and confirm successful communication with peer components.
     * If no peers are specified then will continue without connection confirmation.
     * @param {Set<T>} peers the optional identifiers of components to communicate with
     * @returns {Promise<boolean>} resolves to true if peers are connected, false otherwise
     */
    connect(peers = []) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(peers);
        return new Promise((resolve, reject) => {
            if (!this.communicationService) {
                resolve(false);
                return;
            }
            if (peers.length === 0) {
                resolve(true);
                return;
            }
            else {
                console.warn("Connection confirmation to specific peers is not implemented!");
                this.peers = new Set(peers);
                console.warn("Proceeding without confirmed connection...");
                resolve(true);
                return;
            }
        });
    }
    /**
     * Send a message with payload to specific peers or just broadcast it to all.
     * @param {any} data the payload to send
     * @param {T} targets the identifiers of addressee peers, if none then the message is addressed to all
     */
    send(data, ...targets) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(data);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(targets);
        if (!this.communicationService) {
            return;
        }
        let message = new settings_message_1.SettingsMessage(this.self, targets);
        message.data = data;
        this.communicationService.peerSubject.next(message);
    }
    /**
     * Listen for incoming messages form other peers which are specifically addressed to
     * this component or broadcast to all, and optionally filtered by specific sender.
     * @param {T} source optional sender of the message as an additional filter to accept messages
     * @returns {Observable<any>} emits pre-filtered message data as it arrives
     */
    receive(source) {
        if (!this.communicationService) {
            return Observable_1.Observable.never();
        }
        return this.communicationService.peerObservable
            .filter((message) => {
            return message.source !== this.self && message.isTargetedTo(this.self);
        })
            .filter((message) => {
            return !source || message.source === source;
        })
            .map((message) => {
            return message.data;
        });
    }
    /**
     * Send a message (communication data) to parent.
     * @param {CommunicationKey} key
     */
    sendToParent(key) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(key);
        if (!this.communicationService) {
            return;
        }
        let communicationData = new idm_dynamic_controls_metadata_1.CommunicationData(key);
        this.communicationService.parentSubject.next(communicationData);
    }
    /**
     * Receive a message (communication data) from parent.
     * @returns {Observable<CommunicationData>}
     */
    receiveFromParent() {
        if (!this.communicationService) {
            return Observable_1.Observable.never();
        }
        return this.communicationService.parentObservable;
    }
}
exports.SettingsBase = SettingsBase;
//# sourceMappingURL=settings-base.js.map